export default __webpack_public_path__ + "images/0x8729438eb15e2c8b576fcc6aecda6a148776c0f5.png";